const ProfileRoutes = {
  // updatePicture: "/user/upload",
  updateProfile: "/user/pharmacies/update",
  getProfile: "/user/profile",
  getProfileDetail: "/user/pharmacies/details",
  createPharmacyOrder:"/marketplace/pharmacies/orders/create",
  PharmacyOrderList:"/marketplace/pharmacies/orders"
}

export default ProfileRoutes